import styled from 'styled-components';
import { colors } from '@/styles';

export const StructCell = styled.div`
  /* display: block; */
  /* font-feature-settings: 'tnum'; */
  /* font-variant-numeric: tabular-nums; */
  display: flex;
  height: 100%;
  padding: 4px;
  /* align-items: center; */
  /* & > * {
    display: flex;
  } */

  max-width: 100%;

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /* justify-content: center; */
`;

export const StructDetails = styled.div``;
